/**
* Copyright 2012-2020, Plotly, Inc.
* All rights reserved.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.
*/


'use strict';

module.exports = {
    RELATIVE_CULL_TOLERANCE: 1e-6
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly.js/src/traces/carpet/constants.js
// module id = lPQJ
// module chunks = 0